import * as Sentry from "@sentry/react";
import { ENVIRONMENT } from "@config/app";
import { SENTRY_DSN } from "@config/sentry";

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    enabled: ENVIRONMENT !== "local",
    attachStacktrace: false,
    dataCollection: {
      userInfo: false,
      httpBodies: [],
    },
  });
}
